import axios from "axios";
import moment from "moment";
import { Cookies } from "react-cookie";
import jwt_decode from "jwt-decode";
import { setCookiesSync } from "assets/js/common";
const cookies = new Cookies();
let exec = () => {};

window.appLoginHandle = () => {
  exec();
};

window.appLogoutHandle = () => {
  exec();
};

window.appSetHandle = function() {
  exec();
};

window.appGetHandle = function(json) {
  // alert("appGetHandle");
  exec(json);
};

//login
export const login = (data, returnFunc) => {
  exec = returnFunc;
  if (window.Android) {
    window.Android.login(data.no, "appLoginHandle");
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.ios
  ) {
    // Call iOS interface
    var message = {
      command: "login",
      id: data.no,
      func: "appLoginHandle",
    };
    window.webkit.messageHandlers.ios.postMessage(message);
  }
};

// setAppData
export const setAppData = () => {
  let data = cookies.getAll();
  let params = "";
  if (data["X-AUTH-TOKEN"]) {
    params += `X-AUTH-TOKEN=${encodeURIComponent(data["X-AUTH-TOKEN"])}`;
    params += `&X-REFRESH-TOKEN=${encodeURIComponent(data["X-REFRESH-TOKEN"])}`;
    let myDecodedToken = jwt_decode(data["X-AUTH-TOKEN"]);
    params += `&no=${myDecodedToken.no}`;
  } else {
    params += "X-AUTH-TOKEN=&X-REFRESH-TOKEN=&autoToken=&favInfo=";
  }

  if (data.expires) {
    params += `&expires=${encodeURI(data.expires)}`;
  }
  if (data.checked) {
    params += `&checked=${data.checked}`;
  }

  if (data.autoToken) {
    params += `&autoToken=${encodeURIComponent(data.autoToken)}`;
  }

  if (data.favInfo) {
    params += `&favInfo=${JSON.stringify(data.favInfo)}`;
  }

  if (data.referrer) {
    params += `&referrer=${data.referrer}`;
  }

  if (window.Android) {
    window.Android.set(params);
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.ios
  ) {
    // Call iOS interface
    var message = {
      command: "set",
      params: params,
    };
    window.webkit.messageHandlers.ios.postMessage(message);
  }
};

// getAppData
export const getAppData = (callback) => {
  window.getAppDataReturn = (text) => {
    console.log(text);
    // alert("getAppData : " + text);
    if (text) {
      text = decodeURIComponent(text);
      text = text.replace('"{', "{");
      text = text.replace('}"', "}");
      let json = JSON.parse(text);
      if (json["X-AUTH-TOKEN"]) {
        setCookiesSync(
          "X-AUTH-TOKEN",
          json["X-AUTH-TOKEN"] || cookies.get("X-AUTH-TOKEN")
        );
        setCookiesSync(
          "X-REFRESH-TOKEN",
          json["X-REFRESH-TOKEN"] || cookies.get("X-REFRESH-TOKEN")
        );
        setCookiesSync("no", json.no || cookies.get("no"));
        setCookiesSync("checked", json.checked || cookies.get("checked"));
        setCookiesSync("autoToken", json.autoToken || cookies.get("autoToken"));
        setCookiesSync("favInfo", json.favInfo || cookies.get("favInfo"));
        setCookiesSync("referrer", json.referrer || cookies.get("referrer"));
      }
    }
    callback();
  };

  let params = `expires&X-AUTH-TOKEN&X-REFRESH-TOKEN&no&checked&autoToken&favInfo&referrer&func=getAppDataReturn`;

  if (window.Android) {
    window.Android.get(params);
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.ios
  ) {
    // Call iOS interface
    var message = {
      command: "get",
      params: params,
    };
    window.webkit.messageHandlers.ios.postMessage(message);
  } else {
    getAppDataReturn();
  }
};

// uploadImage
export const upload = (returnFunc) => {
  exec = returnFunc;
  location.href = `csrmegamart://upload?server=image&type=gallery&func=appUploadHandle&wfunc=appUploadWrong&id=1`;
};

// splashHide
export const splashHide = () => {
  if (window.Android) {
    window.Android.hideSplash(0, "");
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.ios
  ) {
    // Call iOS interface
    var message = {
      command: "hideSplash",
      delay: 0,
      func: "",
    };
    window.webkit.messageHandlers.ios.postMessage(message);
  }
};

// setBottomColor

export const setBottomColor = (color) => {
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.ios
  ) {
    // Call iOS interface
    var message = {
      command: "setBottomColor",
      color: color,
      callback: "",
    };
    window.webkit.messageHandlers.ios.postMessage(message);
  }
};

export const goAppPath = (url) => {
  if (window.Android) {
    window.Android.go(url);
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.ios
  ) {
    // Call iOS interface
    var message = {
      command: "go",
      url: url,
    };
    window.webkit.messageHandlers.ios.postMessage(message);
  }
};

export const goAppUrl = (url, top) => {
  if (window.Android) {
    window.Android.goInternalUrl(url, "Y", "N", "", top);
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.ios
  ) {
    // Call iOS interface
    var message = {
      command: "goInternalUrl",
      url: url,
      newYn: "Y",
      closeYn: "N",
      d: "",
      top: top,
    };
    window.webkit.messageHandlers.ios.postMessage(message);
  }
};

export const getAuth = () => {
  location.href = "csrmegamart://auth";
};

export const setPushTag = async () => {
  await axios.get("/api/mb/member/my-info").then((res) => {
    if (res.data.data) {
      let tag = res.data.data.tag;
      if (window.Android) {
        window.Android.setPushTag(tag);
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.ios
      ) {
        // Call iOS interface
        var message = {
          command: "setPushTag",
          tag: tag,
        };
        window.webkit.messageHandlers.ios.postMessage(message);
      }
    }
  });
};

export const openMagamartMall = (key, value) => {
  var scheme = `megamartmall://wakeup`;
  var params = key ? `${key}` + (value ? `=${value}` : "") : "";
  var url = scheme + params;

  if (window.Android) {
    window.Android.openMagamartMall(params);
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.ios
  ) {
    // Call iOS interface
    var message = {
      command: "openMagamartMall",
      url: params,
    };
    window.webkit.messageHandlers.ios.postMessage(message);
  }
};

export const exitApp = () => {
  if (window.Android) {
    window.Android.exitApp();
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.ios
  ) {
    // Call iOS interface
    var message = {
      command: "exitApp",
    };
    window.webkit.messageHandlers.ios.postMessage(message);
  }
};
